import React from 'react'
import PropTypes from 'prop-types'
import Section from './Section'

const Sections = ({ sections }) => {
  const renderable = sections.sort((a, b) => a.position - b.position).map((s,i) => {
    return (
      <Section key={ 'section-' + s.id } section={ s } />
    )
  })

  return (
    <>
      {renderable}
    </>
  )
}

Sections.propTypes = {
  sections: PropTypes.array
}
export default Sections

